import "antd/es/col/style";
import _Col from "antd/es/col";
import "antd/es/row/style";
import _Row from "antd/es/row";
import "antd/es/checkbox/style";
import _Checkbox from "antd/es/checkbox";
var _excluded = ["value"],
    _excluded2 = ["className", "options", "value", "clearWhenOptionsUpdated", "preview", "mutuallyExclusions"],
    _excluded3 = ["label", "value", "extraInfo"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef, useContext } from 'react';
import Typography from '../typography';
import formMethods from '../utils/form-methods';
import omit from 'omit.js';
import classnames from 'classnames';
import { compareOptions, optionsHOC, previewSelectedOptions } from '../utils/option-utils';
import LocaleContext from '../locale/locale-context';
import emptyIcon from '../radio/style/empty.svg';
import './style/index.less'; // add disabled attributes to checkbox options based on mutually exclusion config

var addDisabledAttr = function addDisabledAttr(options, mutuallyExclusions, checkedValues) {
  if (!mutuallyExclusions || !Object.keys(mutuallyExclusions).length || !(checkedValues === null || checkedValues === void 0 ? void 0 : checkedValues.length)) return options;
  return options.map(function (_ref) {
    var value = _ref.value,
        rest = _objectWithoutProperties(_ref, _excluded);

    return _objectSpread(_objectSpread({}, rest), {}, {
      value: value,
      disabled: !!(value && (checkedValues === null || checkedValues === void 0 ? void 0 : checkedValues.some(function (v) {
        var _mutuallyExclusions$S, _mutuallyExclusions$v;

        return v !== value && (((_mutuallyExclusions$S = mutuallyExclusions[String(v)]) === null || _mutuallyExclusions$S === void 0 ? void 0 : _mutuallyExclusions$S.includes(String(value))) || ((_mutuallyExclusions$v = mutuallyExclusions[value]) === null || _mutuallyExclusions$v === void 0 ? void 0 : _mutuallyExclusions$v.includes(String(v))));
      })))
    });
  });
};

var IglooCheckbox = function IglooCheckbox(props) {
  return _jsx(_Checkbox, _objectSpread({}, omit(props, formMethods)));
};

IglooCheckbox.formItemPropsHandler = function (config) {
  return {
    getValueFromEvent: function getValueFromEvent(e) {
      return e.target.checked;
    },
    valuePropName: 'checked'
  };
};

export default IglooCheckbox;

var InnerCheckboxGroup = function InnerCheckboxGroup(_ref2) {
  var className = _ref2.className,
      _ref2$options = _ref2.options,
      options = _ref2$options === void 0 ? [] : _ref2$options,
      value = _ref2.value,
      _ref2$clearWhenOption = _ref2.clearWhenOptionsUpdated,
      clearWhenOptionsUpdated = _ref2$clearWhenOption === void 0 ? false : _ref2$clearWhenOption,
      preview = _ref2.preview,
      mutuallyExclusions = _ref2.mutuallyExclusions,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var originOptions = useRef(options);

  var _useContext = useContext(LocaleContext),
      formatMessage = _useContext.formatMessage;

  useEffect(function () {
    typeof rest.onChange === 'function' && value !== selected && rest.onChange(selected);
  }, [selected]);
  useEffect(function () {
    setSelected(value);
  }, [value]);
  useEffect(function () {
    var setFieldValue = rest.setFieldValue;

    if (compareOptions(options, originOptions.current)) {
      if (clearWhenOptionsUpdated) {
        typeof setFieldValue === 'function' && setFieldValue();
      } else {
        var foundValue = options.find(function (option) {
          return Array.isArray(value) ? value.includes(option.value) : option.value === value;
        });

        if (!foundValue && value !== undefined) {
          typeof setFieldValue === 'function' && setFieldValue();
        }
      }

      originOptions.current = options;
    }
  }, [options]);
  if (preview) return previewSelectedOptions(options, value);
  return _jsxs(_Checkbox.Group, _objectSpread(_objectSpread({}, omit(rest, formMethods)), {}, {
    className: classnames('igloo-checkbox-group', className),
    value: value,
    children: [_jsx(_Row, {
      gutter: [8, 8],
      children: addDisabledAttr(options, mutuallyExclusions, value).map(function (_ref3) {
        var label = _ref3.label,
            key = _ref3.value,
            extraInfo = _ref3.extraInfo,
            rest = _objectWithoutProperties(_ref3, _excluded3);

        return _jsxs(_Col, {
          span: 24,
          className: 'igloo-checkbox-group-normal',
          children: [_jsx(_Checkbox, _objectSpread(_objectSpread({
            value: key
          }, rest), {}, {
            children: _jsx(Typography, {
              level: "body1",
              children: label
            })
          })), _jsx("div", {
            className: "igloo-checkbox-extra",
            children: extraInfo && (extraInfo.shownTrigger === 'all' || extraInfo.shownTrigger === 'checked' && value === key || extraInfo.shownTrigger === 'unchecked' && value !== key) && extraInfo.content
          })]
        }, key);
      })
    }), !options.length && _jsxs("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        background: '#f9f9f9',
        padding: 16,
        alignItems: 'center'
      },
      children: [_jsx("img", {
        src: emptyIcon,
        style: {
          width: 32,
          height: 24
        }
      }), _jsx(Typography, {
        level: "h5",
        style: {
          color: '#212121',
          marginTop: 8
        },
        children: formatMessage({
          id: 'There are no options available currently'
        })
      })]
    })]
  }));
};

export var CheckboxGroup = optionsHOC(InnerCheckboxGroup);
CheckboxGroup.isPreviewSupport = true;

CheckboxGroup.formItemPropsHandler = function () {
  return {};
};